<div class="container-fluid">
  <div class="row justify-content-between">
    <div class="col widget-wrapper">
      <div class="row widget-header hidden-lg-up">
        <div class="col-lg-12">
          <h2>
            Overview
            <a class="btn btn-link help-icon p-0 invisible" data-placement="top" data-toggle="tooltip" enTooltip
              title="">
              <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
            </a>
            <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
          </h2>
        </div>
      </div>
      <div class="row widget-body px-xl-0">
        <div class="col-lg-12 px-0">
          <app-domain-info [isFollowing]='isFollowing' [processingFollow]='processingFollow' [numWatching]="numWatching"
            [domain]="appId" [data]="data" (followButtonClick)='followButtonClick.emit($event)'
            (toAppDiscovery)="toAppDiscovery.emit($event)"
            (followButtonBreakpointReached)='followButtonBreakpointReached.emit($event)'></app-domain-info>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-between pt-lg-4" *ngIf="data.sellersShareDistribution.sellers.length > 0">
    <div class="col widget-wrapper ivt-overview">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>IVT Overview
            <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
              title="The overall percentage of Invalid Traffic (IVT) associated with advertising transactions for the domain.  All IVT calculations are derived from standardized definitions of invalid traffic maintained by the Media Rating Council, Inc. (MRC), Interactive Advertising Bureau (IAB), and Trustworthy Accountability Group (TAG).">
              <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
            </a>
          </h2>
        </div>
      </div>
      <div class="row widget-body ivt-overview px-0">
        <div class="col-lg-12">
          <domain-ivt-overview [data]="data" [isFollowing]="isFollowing"></domain-ivt-overview>
        </div>
      </div>
    </div>
  </div>
</div>